// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-table-title{font-size:21px;color:#195aa6;font-weight:500;margin-bottom:.33em}", ""]);
// Exports
module.exports = exports;
